import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { ChannelQuery } from 'src/app/home/channel/channel.query';

@Component({
  selector: 'app-submitting-order',
  templateUrl: './submitting-order.component.html',
  styleUrls: ['./submitting-order.component.scss']
})
export class SubmittingOrderComponent implements OnInit {
  channelId: number;

  constructor(
    private channelQuery: ChannelQuery,
    private navigationService: NavigationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  async ngOnInit(): Promise<void> {
    this.channelQuery.currentChannelData$.subscribe((data) => {
      if (data) {
        this.channelId = data.channelId;
      }
    });

    // Only run the 7-second countdown in the customer's browser, not on the SSR server!
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.navigationService.navigate(['order-summary']);
      }, 7000);
    }
  }

}
